import { render, staticRenderFns } from "./onSaleSuccess.vue?vue&type=template&id=678eb5c1&scoped=true"
import script from "./onSaleSuccess.vue?vue&type=script&lang=js"
export * from "./onSaleSuccess.vue?vue&type=script&lang=js"
import style0 from "./onSaleSuccess.vue?vue&type=style&index=0&id=678eb5c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678eb5c1",
  null
  
)

export default component.exports